import {
  component$,
  type QRL,
  useSignal,
  type Signal,
  $,
} from "@builder.io/qwik";
import { Modal } from "./ui/modal/modal";
import { useNavigate, usePreventNavigate$ } from "@builder.io/qwik-city";
import { Button } from "./ui/button";

export const usePristineInvalidAlert = (isDirty: QRL<() => boolean>) => {
  const exitUrl = useSignal<number | URL | undefined>(undefined);
  const show = useSignal(false);
  const discardChanges = useSignal(false);
  const nav = useNavigate();

  usePreventNavigate$(async (url) => {
    if (!discardChanges.value && (await isDirty()) && !show.value) {
      if (url) {
        exitUrl.value = url;
        show.value = true;
      }

      return true;
    }

    show.value = false;
    discardChanges.value = false;
    return false;
  });

  const onDiscard$ = $(async () => {
    show.value = false;
    discardChanges.value = true;

    await nav(exitUrl.value);
  });

  return { show, discardChanges, exitUrl, onDiscard$ };
};

export const PristineInvalidAlert = component$<{
  onDiscard$: QRL<() => void>;
  show: Signal<boolean>;
}>(({ show, onDiscard$ }) => {
  return (
    <Modal.Root alert bind:show={show}>
      <Modal.Panel>
        <Modal.Title>You haven&rsquo;t completed this form yet.</Modal.Title>
        <Modal.Description>
          You haven&rsquo;t completed this form yet. Please keep editing and
          make sure to fill out all required fields.
        </Modal.Description>
        <footer class="flex items-center justify-end gap-4">
          <Button variant="ghost" onClick$={() => (show.value = false)}>
            Keep Editing
          </Button>
          <Button variant="destructive" onClick$={onDiscard$}>
            Exit
          </Button>
        </footer>
      </Modal.Panel>
    </Modal.Root>
  );
});
